import { api } from './client'
import type { UploadedImage } from './shop-catalog-api'

// Nội dung trang chủ + liên hệ bán lẻ, dùng chung web + Zalo Mini App (hợp
// đồng v3 §14.20, README 34). Ảnh là object {url, thumb_url}; khi gửi chỉ cần
// url (server bỏ thumb_url).

/** 7 khối trang chủ, đúng thứ tự trên trang (code cố định, không kéo thả). */
export const SHOP_HOME_KINDS = [
    'hero_slide',
    'home_tab',
    'promo',
    'gift_banner',
    'story',
    'ocop',
    'store_system',
] as const

export type ShopHomeKind = (typeof SHOP_HOME_KINDS)[number]

export interface ShopHomeImage {
    url: string
    thumb_url?: string
}

export interface ShopHomeItem {
    id: string
    enabled: boolean
    show_web: boolean
    show_miniapp: boolean
    starts_at: string | null
    ends_at: string | null
    data: Record<string, unknown>
}

export interface ShopHomeSection {
    kind: ShopHomeKind
    enabled: boolean
    show_web: boolean
    show_miniapp: boolean
    starts_at: string | null
    ends_at: string | null
    version: number
    updated_at: string
    data: Record<string, unknown>
    items: ShopHomeItem[]
}

export interface ShopHomeItemInput {
    id?: string
    enabled: boolean
    show_web: boolean
    show_miniapp: boolean
    starts_at?: string | null
    ends_at?: string | null
    data: Record<string, unknown>
}

export interface ShopHomeSectionInput {
    version: number
    enabled: boolean
    show_web: boolean
    show_miniapp: boolean
    starts_at?: string | null
    ends_at?: string | null
    data?: Record<string, unknown>
    items?: ShopHomeItemInput[]
}

export interface ShopContactFields {
    site_name: string | null
    hotline: string | null
    hotline2: string | null
    zalo: string | null
    email: string | null
    opening_hours: string | null
    address: string | null
    tax_info: string | null
    map_embed_url: string | null
}

export interface ShopContact extends ShopContactFields {
    version: number
    updated_at: string
}

export interface ShopContactInput extends ShopContactFields {
    version: number
}

export const shopContentApi = {
    home: () => api.get<{ sections: ShopHomeSection[] }>('/shop-admin/home'),
    saveHome: (kind: ShopHomeKind, input: ShopHomeSectionInput) =>
        api.put<ShopHomeSection>(`/shop-admin/home/${kind}`, input),
    contact: () => api.get<ShopContact>('/shop-admin/contact'),
    saveContact: (input: ShopContactInput) =>
        api.put<ShopContact>('/shop-admin/contact', input),
    /** Upload ảnh cho màn nội dung — gác bằng shop_content.write. */
    uploadImage: (file: File) => {
        const form = new FormData()
        form.append('file', file)
        return api.post<UploadedImage>('/shop-admin/content/uploads', form)
    },
}
